import { AuthStatus } from "@/types/my-tasks";

export const AUTH_STATUS: AuthStatus[] = [
  "Not Started",
  "Pending",
  "Not Required",
  "Obtained",
  "Closed",
];

export const AUTH_STATUS_BACKEND = AUTH_STATUS.map(status => status.toUpperCase().replace(" ", "_"));
